import Cookies from "universal-cookie";
import { expireTime } from "utils";

const cookies = new Cookies();

class BrowserService {
    getCookie(key) {
        return cookies.get(key);
    }

    setCookie(key, data) {
        cookies.set(key, data, { path: "/", expires: expireTime() });
    }

    removeCookie(key) {
        cookies.remove(key, { path: "/", expires: expireTime() });
    }
}

export default new BrowserService();